export default "__VITE_PUBLIC_ASSET__93e99c22__"